import React, { useState, useEffect, useRef } from "react";
import { BiDownload, BiFile, BiPowerOff } from "react-icons/bi";
import { ToastContainer, toast } from 'react-toastify';
import { apiCallingPost, apiCallingGetDecrypted } from '../../api/services';
import { FaDownload, FaEye } from "react-icons/fa";
import { IoCloseOutline } from "react-icons/io5";
import Logo from "../../assets/images/logo-blue.svg"
import JSZip from "jszip";
import { saveAs } from "file-saver";
import moment from 'moment';
import { useSelector } from 'react-redux';
import { setPageUrl } from "../../redux/reducers/authSlice";
import { useDispatch } from "react-redux";
function ListVideo() {

  const [requestDetails, setRequestDetails] = useState([])
  const [loadingStatusIndex, setLoadingStatusIndex] = useState(null)
  const [messageExpired, setMessageExpired] = useState("")
  const [totalCount, setTotalCount] = useState(null)
  const [totalFileSize, setTotalFileSize] = useState(0)
  const [mode, setmode] = useState(null)
  const [expireAt, setExpireAt] = useState("")
  const [showVideo, setShowVideo] = useState(false);
  const [videoUrl, setVideoUrl] = useState("")
  const { isAuthenticated } = useSelector((state) => state.authentication)
  const [selectedQualities, setSelectedQualities] = useState({});
  const [setFileType, setSetFileType] = useState("")
  const dispatch = useDispatch();

  if (!isAuthenticated) {
    dispatch(setPageUrl(window.location.pathname))
    window.location.href = "/login"

  }
  useEffect(() => {
    shareRequestExpire()

  }, [])
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setShowVideo(false);
        setVideoUrl("");
        setSetFileType("");
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  const shareRequestExpire = async (list) => {
    const initialSelectedQualities = {};

    let postData = {
      encodedVideoUrl: window.location.href
    }

    try {
      const response = await apiCallingPost("api/video/checkShareRequestDurationExpire", postData);
      const { data } = response;
      //console.log("🚀 ~ shareRequestExpire ~ data:", data)
      if (data.success === "1") {
        setRequestDetails(data.result?.[0]?.requestDetails)
        setMessageExpired(data.result?.[0]?.message)
        setTotalCount(data.result?.[0]?.totalCount)
        setTotalFileSize(data.result?.[0]?.totalFileSize)
        setmode(data.result?.[0]?.mode)
        const formattedDate = moment(JSON.parse(data.result?.[0]?.expires_at)).format('MMM D, YYYY, h:mm:ss A');
        setExpireAt(formattedDate)

        data.result?.[0]?.requestDetails.forEach((video) => {
          if (video.download_mp4 && !video.download_original && video.qualityTypeArray.length > 0) {
            initialSelectedQualities[video.video_id] = {
              quality: video.qualityTypeArray[0].qualitytype,
              size: video.qualityTypeArray[0].qualityvideosize,
            };
          } else {
            // Use original
            initialSelectedQualities[video.video_id] = {
              quality: "Download Original",
              size: Number(video.file_size),
            };
          }
        });
        setSelectedQualities(initialSelectedQualities);
        const totalSizeMB = Object.values(initialSelectedQualities).reduce(
          (sum, item) => sum + Number(item.size),
          0
        );
        setTotalFileSize(totalSizeMB.toFixed(1));
      }
      else {
        toast.error("Please try again.");
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  }
  const getTotalSize = (videos) => {
    const totalMB = videos.reduce((sum, video) => sum + Number(video.file_size), 0);

    if (totalMB >= 1024 * 1024) {
      const totalTB = totalMB / (1024 * 1024);
      return `${totalTB.toFixed(1)} TB`;
    } else if (totalMB >= 1024) {
      const totalGB = totalMB / 1024;
      return `${totalGB.toFixed(1)} GB`;
    } else {
      return `${totalMB.toFixed(1)} MB`;
    }
  };
  const getSelectedQualityArray = () => {
    return requestDetails.map((video) => {
      const selected = selectedQualities[video.video_id];
      return {
        fileId: video.video_id,
        type: selected?.quality === "Download Original" || !selected?.quality ? "" : selected.quality,
      };
    });
  };

  const handleDownloadAll = async () => {
    const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");
    const selectedResolutionArray = getSelectedQualityArray();
    const encoded = encodeURIComponent(JSON.stringify(selectedResolutionArray));

    const { responseData } = await apiCallingGetDecrypted(`api/download/download_zip?videoId=${encoded}`);
    const link = document.createElement('a');
    link.href = responseData;
    link.download = "video.zip"//`${JSON.stringify(currentDateTime)}+.zip`; // optional: helps some browsers
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  }

  const handleDownload = async (video) => {
    setLoadingStatusIndex(video.video_id)
    const videoUrl = video.videoUrl;
    try {
      const response = await fetch(videoUrl);
      if (!response.ok) {
        throw new Error("File download failed!");
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = `${videoUrl}`;
      document.body.appendChild(anchor);
      anchor.click();

      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(anchor);
    } catch (error) {
      toast.error("Failed to download the file. Please try again.");
    }
    setLoadingStatusIndex(null)
  };
  const handleToggleVideo = (url, fileTypeId) => {
    setShowVideo((prev) => !prev);
    setVideoUrl(url)
    setSetFileType(fileTypeId)
  };
  const cancelpopup = () => {
    window.location.href = "/"
  }
  const getTotalSizeMB = (mb) => {
    if (mb >= 1024 * 1024) return `${(mb / (1024 * 1024)).toFixed(1)} TB`;
    if (mb >= 1024) return `${(mb / 1024).toFixed(1)} GB`;
    return `${mb} MB`;
  };
  const handleQualityChange = (videoId, selectedQuality, sizes) => {
    const selectedVideoSize = sizes.find(q => q.qualitytype === selectedQuality)?.qualityvideosize || 0;
    setSelectedQualities(prev => {
      const updated = {
        ...prev,
        [videoId]: { quality: selectedQuality, size: selectedVideoSize }
      };

      // Update total size
      const totalSizeMB = requestDetails.reduce((sum, video) => {
        const selected = updated[video.video_id];
        return sum + (selected?.size ? Number(selected.size) : Number(video.file_size));
      }, 0);
      setTotalFileSize(totalSizeMB.toFixed(1));

      return updated;
    });
  };
  const handleSingleDownload = async (video, selectedQualityObj) => {

    const resolutionType = selectedQualityObj?.quality === "Download Original" || !selectedQualityObj?.quality
      ? ""
      : selectedQualityObj.quality;

    const requestPayload = [{
      fileId: video.video_id,
      type: resolutionType
    }];

    const encoded = encodeURIComponent(JSON.stringify(requestPayload));

    try {
      const { responseData } = await apiCallingGetDecrypted(`api/download/download_zip?videoId=${encoded}`);

      const link = document.createElement('a');
      link.href = responseData;
      link.download = `${video.filename}.${video.file_extension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Single download failed", err);
    }
  };

  return (
    isAuthenticated && (
      <div className="modal-admin-wrapper">
        <div className="py-3">
          <img src={Logo} alt="Logo" className="img-fluid" width="120" height="50" />
        </div>
        {messageExpired == "Expired" ?
          <div className="noData d-flex align-items-center ">
            <p className=" text-center expired-message px-4">
              The link you’re trying to access is no longer valid or has expired.
            </p>
          </div>
          :
          <div className="modal-ad-popup modal-md">
            <div className="modal-innerpopup ">
              <div className="modal-headdiv d-flex justify-content-between">
                <h5 className="modal-head">Files are Ready!</h5>
                <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelpopup()} /></span>
              </div>
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <div className="d-flex align-items-center gap-2"> <BiFile /><strong>{totalCount} files, {getTotalSizeMB(totalFileSize)} </strong></div>
                <div className="d-flex align-items-center gap-2 ms-auto"><BiPowerOff /><strong>Expires on {expireAt}</strong></div>
              </div>
              <div className="modal-admin-body my-3" style={{ maxHeight: 'calc(100vh - 290px)' }}>
                <div className="table-responsive">
                  <table className="table table-bordered admin-list-table">

                    <tbody>

                      {requestDetails.map((data, i) => {
                        return (
                          < tr key={i} >
                            <td style={mode === "Download"
                              ? { width: '40%', minWidth: '250px' }
                              : { width: '70%', minWidth: '250px' }}>{data.video_name}{"." + data.file_extension}</td>
                            <td style={{ width: '20%', minWidth: '100px' }}>
                              {selectedQualities[data.video_id]?.size
                                ? `${selectedQualities[data.video_id].size} MB`
                                : (data.download_mp4 && !data.download_original) ? data.qualityTypeArray.length > 0 ? `${data.qualityTypeArray[0].qualityvideosize} MB` : `${data.file_size} MB` : `${data.file_size} MB`}
                            </td>
                            <td style={mode === "Download"
                              ? { width: '40%', minWidth: '250px' }
                              : { width: '10%', minWidth: '60px' }}>
                              <div className="d-flex align-items-center gap-3"
                                style={{ color: '#00627B' }}
                              >
                                {mode === "Download" &&
                                  <select name="" id="" className='form-control form-select-drop'
                                    value={selectedQualities[data.video_id]?.quality || "Download Original"}
                                    onChange={(e) =>
                                      handleQualityChange(data.video_id, e.target.value, data.qualityTypeArray)
                                    }
                                  >
                                    {(data.download_original || data.fileTypeId == "1") &&
                                      <option value="Download Original" >Download Original</option>}
                                    {data.download_mp4 &&
                                      data.qualityTypeArray.map((obj, j) => (
                                        <option key={j} value={obj.qualitytype}>{obj.qualitytype}</option>
                                      ))}
                                  </select>}

                                <FaEye style={{ cursor: 'pointer', fontSize: '24px', flex: 'none' }} onClick={() => handleToggleVideo(data.videoUrl, data.fileTypeId)} />
                                {mode === "Download" &&
                                  <span style={{ flex: 'none' }} onClick={() => handleSingleDownload(data, selectedQualities[data.video_id])}
                                  // disabled={loadingStatusIndex == data.video_id}
                                  >
                                    {/* {loadingStatusIndex === data.video_id ? "Downloading..." : */}
                                    <FaDownload />
                                    {/* } */}
                                  </span>}
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>

                  </table>
                </div>
              </div>
              <div className="tag-popup-footer">
                <div className="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    className="accept-all-btn w-100 py-2 accept-all-gray"
                    onClick={() => cancelpopup()}
                  >
                    Cancel
                  </button>
                  {mode === "Download" &&
                    (<button
                      type="button"
                      className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                      onClick={() => handleDownloadAll()}
                    >
                      Download all <BiDownload className="ms-0" />
                    </button>)}
                </div>
              </div>
            </div>
          </div>}
        {showVideo && (
          <div style={styles.overlay}>
            <button style={styles.closeButton} onClick={() => setShowVideo(false)}>×</button>
            {setFileType == "1" ?
              <img src={videoUrl} className="card-img-top card-video-img" alt="..."
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',       // fill and crop to fit container
                  backgroundColor: "#f1f1f1"
                }}
              />
              :
              <video src={videoUrl} controls autoPlay style={styles.video} />

            }


            {/* <video
            width="480"
            controls
            autoPlay
            src={videoUrl}
          >
            Your browser does not support the video tag.
          </video> */}
          </div>
        )}
      </div >
    )
  );
}
const styles = {
  overlay: {
    position: 'fixed',
    zIndex: 9999,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0,0,0,0.95)',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  video: {
    maxWidth: '90%',
    maxHeight: '90%',
  },
  closeButton: {
    position: 'absolute',
    top: '20px',
    right: '30px',
    fontSize: '36px',
    color: '#fff',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
  },
};
export default ListVideo;